import { render } from "./LoginUser.vue?vue&type=template&id=5db58b23"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"

import "./LoginUser.vue?vue&type=style&index=0&id=5db58b23&lang=scss"

import exportComponent from "C:\\work\\bogdan\\altmedia-admin-dash\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__